import { gql } from '@apollo/client';

import { GROUP_ZOOM_SCHEDULE_FIELDS } from '../fragments/zoom';

/**
 * NB: operation names are prefixed `Zoom…` and deliberately differ from the
 * server payload type names (`SyncZoomAccountsMutation`, …). graphql-codegen
 * derives the operation result type as `<OperationName>Mutation`; reusing the
 * schema payload name would emit a duplicate identifier in `hooks.ts`.
 */

export const ZoomSyncAccountsMutation = gql`
  mutation ZoomSyncAccounts {
    syncZoomAccounts {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomSyncRecordingsMutation = gql`
  mutation ZoomSyncRecordings($date: Date!) {
    syncZoomRecordings(date: $date) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomRefreshAllMutation = gql`
  mutation ZoomRefreshAll($dateFrom: Date, $dateTo: Date) {
    refreshAllZoomData(dateFrom: $dateFrom, dateTo: $dateTo) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomSyncAllRecordingsMutation = gql`
  mutation ZoomSyncAllRecordings($dateFrom: Date, $dateTo: Date) {
    syncAllZoomRecordings(dateFrom: $dateFrom, dateTo: $dateTo) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomSyncUsageMutation = gql`
  mutation ZoomSyncUsage {
    syncZoomUsage {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomRunAutoMatchingMutation = gql`
  mutation ZoomRunAutoMatching($date: Date!) {
    runAutoMatching(date: $date) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomSetGroupAccountMutation = gql`
  mutation ZoomSetGroupAccount($groupId: ID!, $zoomAccountId: ID) {
    setGroupZoomAccount(groupId: $groupId, zoomAccountId: $zoomAccountId) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomSetGroupScheduleMutation = gql`
  ${GROUP_ZOOM_SCHEDULE_FIELDS}
  mutation ZoomSetGroupSchedule(
    $groupId: ID!
    $zoomAccountId: ID
    $slots: [GroupZoomScheduleSlotInput!]!
  ) {
    setGroupZoomSchedule(
      groupId: $groupId
      zoomAccountId: $zoomAccountId
      slots: $slots
    ) {
      success
      customErrors {
        field
        message
        code
      }
      schedules {
        ...GroupZoomScheduleFields
      }
    }
  }
`;

export const ZoomCreateManualMatchMutation = gql`
  mutation ZoomCreateManualMatch($lessonId: ID!, $zoomRecordingId: ID!) {
    createManualLessonRecording(
      lessonId: $lessonId
      zoomRecordingId: $zoomRecordingId
    ) {
      success
      customErrors {
        field
        message
        code
      }
      lessonRecording {
        id
        status
      }
    }
  }
`;

export const ZoomUnlinkRecordingMutation = gql`
  mutation ZoomUnlinkRecording($id: ID!) {
    unlinkLessonRecording(id: $id) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomMarkMissingMutation = gql`
  mutation ZoomMarkMissing($lessonId: ID!) {
    markLessonMissingRecording(lessonId: $lessonId) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomRetryRecordingMutation = gql`
  mutation ZoomRetryRecording($id: ID!) {
    retryLessonRecording(id: $id) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomReprocessAiMutation = gql`
  mutation ZoomReprocessAi($id: ID!) {
    reprocessAi(id: $id) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const ZoomDeleteRecordingMutation = gql`
  mutation ZoomDeleteRecording($id: ID!, $confirm: String!) {
    deleteZoomRecording(id: $id, confirm: $confirm) {
      success
      customErrors {
        field
        message
        code
      }
      zoomRecording {
        id
        pk
        deletedFromZoom
        deletedAt
      }
    }
  }
`;

export const ZoomSendMorningReportMutation = gql`
  mutation ZoomSendMorningReport($date: Date) {
    sendMorningReport(date: $date) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;
